<template lang="pug">
div(@click="onCard"
  ).wrap-item-asset-card.s-w-full.mb16.cursor-pointer
  div.wrap-img.relative.f.fh.w-full.mb8
    div.wrap-type.absolute.t8.l8.f.fh.w24.h24.rounded
      v-icon(dark size="16px") {{getIconByAssetType(asset.type)}}
    img(:src="asset.mainImg").object-fit-cover.h-full
  div
    span.block.line-clamp-1.mb4 {{asset.name}}
    div.wrap-tags.f.flex-wrap
      span(v-for="tag in asset.tags").tag.fz14.px8.py4.mr8.mb8.rounded {{'#' + tag}}
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-item-asset-card {
  width: 49.5%;
  .wrap-img {
    height: 240px;
    overflow: hidden;
    img {
      max-height: 240px;
    }
    .wrap-type {
      background: rgba(0, 0, 0, 0.3);
      span {
        color: $dark_primary_text_color;
      }
    }
  }
  .wrap-tags {
    .tag {
      border: $basic_border;
    }
  }
}
</style>

<script>

export default {
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  computed: {
    path () {
      const assetId = this.asset.id ? this.asset.id : this.asset.objectID
      return `${window.location.origin}/asset/${assetId}`
    }
  },
  methods: {
    onCard () {
      // this.$router.push(`/asset/${this.asset.id}`)
      window.open(this.path, '_blank')
    }
  }
}
</script>
